"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgSettings(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("path", {
        id: "settings_svg__a",
        d: "M16.213 8.367l-1.26-.42.594-1.187A.667.667 0 0015.42 6L14 4.58a.668.668 0 00-.767-.127l-1.186.594-.42-1.26A.667.667 0 0011 3.333H9a.666.666 0 00-.633.454l-.42 1.26-1.187-.594A.667.667 0 006 4.58L4.58 6a.668.668 0 00-.127.767l.594 1.186-1.26.42A.667.667 0 003.333 9v2c0 .287.182.542.454.633l1.26.42-.594 1.187a.667.667 0 00.127.76L6 15.42c.202.202.51.253.767.127l1.186-.594.42 1.26a.668.668 0 00.634.454h2a.668.668 0 00.633-.454l.42-1.26 1.187.594c.252.12.553.07.753-.127L15.42 14a.668.668 0 00.127-.767l-.594-1.186 1.26-.42a.667.667 0 00.454-.627V9a.666.666 0 00-.454-.633zm-.88 2.153l-.8.267a1.332 1.332 0 00-.773 1.88l.38.76-.733.733-.74-.4a1.333 1.333 0 00-1.86.773l-.267.8H9.48l-.267-.8a1.332 1.332 0 00-1.88-.773l-.76.38-.733-.733.4-.74a1.334 1.334 0 00-.773-1.88l-.8-.267V9.48l.8-.267a1.332 1.332 0 00.773-1.88l-.38-.74.733-.733.74.38a1.334 1.334 0 001.88-.773l.267-.8h1.04l.267.8a1.332 1.332 0 001.88.773l.76-.38.733.733-.4.74a1.333 1.333 0 00.773 1.86l.8.267v1.06zM10 7.333a2.667 2.667 0 100 5.332 2.667 2.667 0 000-5.331zm0 4a1.333 1.333 0 110-2.667 1.333 1.333 0 010 2.667z"
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("mask", {
        id: "settings_svg__b",
        fill: "currentColor",
        children: (0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#settings_svg__a"
        })
      }), (0, _jsxRuntime.jsx)("use", {
        fill: "currentColor",
        fillRule: "nonzero",
        xlinkHref: "#settings_svg__a"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "currentColor",
        d: "M0 0h20v20H0z",
        mask: "url(#settings_svg__b)"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Settings.js.map